//
//
//
//
//
//

import MHeader from './header.vue';
import MContent from './content.vue';
export default {
    components: {
        MHeader,
        MContent
    }
};



// WEBPACK FOOTER //
// ./src/components/Search/Search.vue